/**
 * Google Fonts metadata including available weights and variable font info.
 * Auto-generated from https://fonts.google.com/metadata/fonts
 * Generated on: 2026-01-10T22:34:39.391Z
 *
 * To regenerate, run:
 *   pnpm --filter schemas gen:font-metadata
 */

export const GOOGLE_FONTS_METADATA: Record<
  string,
  { weights: number[]; variable: boolean }
> = {
  ABeeZee: { weights: [400], variable: false },
  "ADLaM Display": { weights: [400], variable: false },
  "AR One Sans": { weights: [400, 500, 600, 700], variable: true },
  Abel: { weights: [400], variable: false },
  "Abhaya Libre": { weights: [400, 500, 600, 700, 800], variable: false },
  Aboreto: { weights: [400], variable: false },
  "Abril Fatface": { weights: [400], variable: false },
  "Abyssinica SIL": { weights: [400], variable: false },
  Aclonica: { weights: [400], variable: false },
  Acme: { weights: [400], variable: false },
  Actor: { weights: [400], variable: false },
  Adamina: { weights: [400], variable: false },
  "Advent Pro": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Afacad: { weights: [400, 500, 600, 700], variable: true },
  "Afacad Flux": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  Agbalumo: { weights: [400], variable: false },
  Agdasima: { weights: [400, 700], variable: false },
  "Agu Display": { weights: [400], variable: false },
  "Aguafina Script": { weights: [400], variable: false },
  Akatab: { weights: [400, 500, 600, 700, 800, 900], variable: false },
  "Akaya Kanadaka": { weights: [400], variable: false },
  "Akaya Telivigala": { weights: [400], variable: false },
  Akronim: { weights: [400], variable: false },
  Akshar: { weights: [300, 400, 500, 600, 700], variable: true },
  Aladin: { weights: [400], variable: false },
  "Alan Sans": { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  Alata: { weights: [400], variable: false },
  Alatsi: { weights: [400], variable: false },
  "Albert Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Aldrich: { weights: [400], variable: false },
  Alef: { weights: [400, 700], variable: false },
  Alegreya: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Alegreya SC": { weights: [400, 500, 700, 800, 900], variable: false },
  "Alegreya Sans": {
    weights: [100, 300, 400, 500, 700, 800, 900],
    variable: false,
  },
  "Alegreya Sans SC": {
    weights: [100, 300, 400, 500, 700, 800, 900],
    variable: false,
  },
  Aleo: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Alex Brush": { weights: [400], variable: false },
  Alexandria: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Alfa Slab One": { weights: [400], variable: false },
  Alice: { weights: [400], variable: false },
  Alike: { weights: [400], variable: false },
  "Alike Angular": { weights: [400], variable: false },
  Alkalami: { weights: [400], variable: false },
  Alkatra: { weights: [400, 500, 600, 700], variable: true },
  Allan: { weights: [400, 700], variable: false },
  Allerta: { weights: [400], variable: false },
  "Allerta Stencil": { weights: [400], variable: false },
  Allison: { weights: [400], variable: false },
  Allura: { weights: [400], variable: false },
  Almarai: { weights: [300, 400, 700, 800], variable: false },
  Almendra: { weights: [400, 700], variable: false },
  "Almendra Display": { weights: [400], variable: false },
  "Almendra SC": { weights: [400], variable: false },
  "Alumni Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Alumni Sans Collegiate One": { weights: [400], variable: false },
  "Alumni Sans Inline One": { weights: [400], variable: false },
  "Alumni Sans Pinstripe": { weights: [400], variable: false },
  "Alumni Sans SC": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Amarante: { weights: [400], variable: false },
  Amaranth: { weights: [400, 700], variable: false },
  Amarna: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  "Amatic SC": { weights: [400, 700], variable: false },
  Amethysta: { weights: [400], variable: false },
  Amiko: { weights: [400, 600, 700], variable: false },
  Amiri: { weights: [400, 700], variable: false },
  "Amiri Quran": { weights: [400], variable: false },
  Amita: { weights: [400, 700], variable: false },
  Anaheim: { weights: [400, 500, 600, 700, 800], variable: true },
  "Ancizar Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Ancizar Serif": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Andada Pro": { weights: [400, 500, 600, 700, 800], variable: true },
  Andika: { weights: [400, 700], variable: false },
  "Anek Bangla": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Devanagari": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Gujarati": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Gurmukhi": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Kannada": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Latin": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Malayalam": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Odia": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Tamil": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Anek Telugu": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Angkor: { weights: [400], variable: false },
  "Annapurna SIL": { weights: [400, 700], variable: false },
  "Annie Use Your Telescope": { weights: [400], variable: false },
  "Anonymous Pro": { weights: [400, 700], variable: false },
  Anta: { weights: [400], variable: false },
  Antic: { weights: [400], variable: false },
  "Antic Didone": { weights: [400], variable: false },
  "Antic Slab": { weights: [400], variable: false },
  Anton: { weights: [400], variable: false },
  "Anton SC": { weights: [400], variable: false },
  Antonio: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  Anuphan: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  Anybody: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Aoboshi One": { weights: [400], variable: false },
  Arapey: { weights: [400], variable: false },
  Arbutus: { weights: [400], variable: false },
  "Arbutus Slab": { weights: [400], variable: false },
  "Architects Daughter": { weights: [400], variable: false },
  Archivo: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Archivo Black": { weights: [400], variable: false },
  "Archivo Narrow": { weights: [400, 500, 600, 700], variable: true },
  "Are You Serious": { weights: [400], variable: false },
  "Aref Ruqaa": { weights: [400, 700], variable: false },
  "Aref Ruqaa Ink": { weights: [400, 700], variable: false },
  Arima: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  Arimo: { weights: [400, 500, 600, 700], variable: true },
  Arizonia: { weights: [400], variable: false },
  Armata: { weights: [400], variable: false },
  Arsenal: { weights: [400, 700], variable: false },
  "Arsenal SC": { weights: [400, 700], variable: false },
  Artifika: { weights: [400], variable: false },
  Arvo: { weights: [400, 700], variable: false },
  Arya: { weights: [400, 700], variable: false },
  Asap: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Asap Condensed": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Asar: { weights: [400], variable: false },
  Asimovian: { weights: [400], variable: false },
  Asset: { weights: [400], variable: false },
  Assistant: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Asta Sans": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Astloch: { weights: [400, 700], variable: false },
  Asul: { weights: [400, 700], variable: false },
  Athiti: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Atkinson Hyperlegible": { weights: [400, 700], variable: false },
  "Atkinson Hyperlegible Mono": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Atkinson Hyperlegible Next": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Atma: { weights: [300, 400, 500, 600, 700], variable: false },
  "Atomic Age": { weights: [400], variable: false },
  Aubrey: { weights: [400], variable: false },
  Audiowide: { weights: [400], variable: false },
  "Autour One": { weights: [400], variable: false },
  Average: { weights: [400], variable: false },
  "Average Sans": { weights: [400], variable: false },
  "Averia Gruesa Libre": { weights: [400], variable: false },
  "Averia Libre": { weights: [300, 400, 700], variable: false },
  "Averia Sans Libre": { weights: [300, 400, 700], variable: false },
  "Averia Serif Libre": { weights: [300, 400, 700], variable: false },
  "Azeret Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  B612: { weights: [400, 700], variable: false },
  "B612 Mono": { weights: [400, 700], variable: false },
  "BBH Bartle": { weights: [400], variable: false },
  "BBH Bogle": { weights: [400], variable: false },
  "BBH Hegarty": { weights: [400], variable: false },
  "BIZ UDGothic": { weights: [400, 700], variable: false },
  "BIZ UDMincho": { weights: [400, 700], variable: false },
  "BIZ UDPGothic": { weights: [400, 700], variable: false },
  "BIZ UDPMincho": { weights: [400, 700], variable: false },
  Babylonica: { weights: [400], variable: false },
  "Bacasime Antique": { weights: [400], variable: false },
  "Bad Script": { weights: [400], variable: false },
  "Badeen Display": { weights: [400], variable: false },
  "Bagel Fat One": { weights: [400], variable: false },
  Bahiana: { weights: [400], variable: false },
  Bahianita: { weights: [400], variable: false },
  "Bai Jamjuree": { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Bakbak One": { weights: [400], variable: false },
  Ballet: { weights: [400], variable: false },
  "Baloo 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Bhai 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Bhaijaan 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Bhaina 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Chettan 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Da 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Paaji 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Tamma 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Tammudu 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Baloo Thambi 2": { weights: [400, 500, 600, 700, 800], variable: true },
  "Balsamiq Sans": { weights: [400, 700], variable: false },
  Balthazar: { weights: [400], variable: false },
  Bangers: { weights: [400], variable: false },
  Barlow: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Barlow Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Barlow Semi Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Barriecito: { weights: [400], variable: false },
  Barrio: { weights: [400], variable: false },
  Basic: { weights: [400], variable: false },
  Baskervville: { weights: [400, 500, 600, 700], variable: true },
  "Baskervville SC": { weights: [400, 500, 600, 700], variable: true },
  Battambang: { weights: [100, 300, 400, 700, 900], variable: false },
  Baumans: { weights: [400], variable: false },
  Bayon: { weights: [400], variable: false },
  "Be Vietnam Pro": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Beau Rivage": { weights: [400], variable: false },
  "Bebas Neue": { weights: [400], variable: false },
  Beiruti: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Belanosima: { weights: [400, 600, 700], variable: false },
  Belgrano: { weights: [400], variable: false },
  Bellefair: { weights: [400], variable: false },
  Belleza: { weights: [400], variable: false },
  Bellota: { weights: [300, 400, 700], variable: false },
  "Bellota Text": { weights: [300, 400, 700], variable: false },
  BenchNine: { weights: [300, 400, 700], variable: false },
  Benne: { weights: [400], variable: false },
  Bentham: { weights: [400], variable: false },
  "Berkshire Swash": { weights: [400], variable: false },
  Besley: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Beth Ellen": { weights: [400], variable: false },
  Bevan: { weights: [400], variable: false },
  "BhuTuka Expanded One": { weights: [400], variable: false },
  "Big Shoulders": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Big Shoulders Inline": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Big Shoulders Stencil": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bigelow Rules": { weights: [400], variable: false },
  "Bigshot One": { weights: [400], variable: false },
  Bilbo: { weights: [400], variable: false },
  "Bilbo Swash Caps": { weights: [400], variable: false },
  BioRhyme: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "BioRhyme Expanded": { weights: [200, 300, 400, 700, 800], variable: false },
  Birthstone: { weights: [400], variable: false },
  "Birthstone Bounce": { weights: [400, 500], variable: false },
  Biryani: { weights: [200, 300, 400, 600, 700, 800, 900], variable: false },
  Bitcount: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Grid Double": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Grid Double Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Grid Single": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Grid Single Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Prop Double": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Prop Double Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Prop Single": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Prop Single Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Single": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Bitcount Single Ink": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Bitter: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Black And White Picture": { weights: [400], variable: false },
  "Black Han Sans": { weights: [400], variable: false },
  "Black Ops One": { weights: [400], variable: false },
  Blaka: { weights: [400], variable: false },
  "Blaka Hollow": { weights: [400], variable: false },
  "Blaka Ink": { weights: [400], variable: false },
  Blinker: {
    weights: [100, 200, 300, 400, 600, 700, 800, 900],
    variable: false,
  },
  "Bodoni Moda": { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Bodoni Moda SC": { weights: [400, 500, 600, 700, 800, 900], variable: true },
  Bokor: { weights: [400], variable: false },
  Boldonse: { weights: [400], variable: false },
  "Bona Nova": { weights: [400, 700], variable: false },
  "Bona Nova SC": { weights: [400, 700], variable: false },
  Bonbon: { weights: [400], variable: false },
  "Bonheur Royale": { weights: [400], variable: false },
  Boogaloo: { weights: [400], variable: false },
  Borel: { weights: [400], variable: false },
  "Bowlby One": { weights: [400], variable: false },
  "Bowlby One SC": { weights: [400], variable: false },
  "Braah One": { weights: [400], variable: false },
  Brawler: { weights: [400, 700], variable: false },
  "Bree Serif": { weights: [400], variable: false },
  "Bricolage Grotesque": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Bruno Ace": { weights: [400], variable: false },
  "Bruno Ace SC": { weights: [400], variable: false },
  "Brygada 1918": { weights: [400, 500, 600, 700], variable: true },
  "Bubblegum Sans": { weights: [400], variable: false },
  "Bubbler One": { weights: [400], variable: false },
  Buda: { weights: [300], variable: false },
  Buenard: { weights: [400, 500, 600, 700], variable: true },
  Bungee: { weights: [400], variable: false },
  "Bungee Hairline": { weights: [400], variable: false },
  "Bungee Inline": { weights: [400], variable: false },
  "Bungee Outline": { weights: [400], variable: false },
  "Bungee Shade": { weights: [400], variable: false },
  "Bungee Spice": { weights: [400], variable: false },
  "Bungee Tint": { weights: [400], variable: false },
  Butcherman: { weights: [400], variable: false },
  "Butterfly Kids": { weights: [400], variable: false },
  Bytesized: { weights: [400], variable: false },
  Cabin: { weights: [400, 500, 600, 700], variable: true },
  "Cabin Condensed": { weights: [400, 500, 600, 700], variable: false },
  "Cabin Sketch": { weights: [400, 700], variable: false },
  "Cactus Classical Serif": { weights: [400], variable: false },
  "Caesar Dressing": { weights: [400], variable: false },
  Cagliostro: { weights: [400], variable: false },
  Cairo: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Cairo Play": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Cal Sans": { weights: [400], variable: false },
  Caladea: { weights: [400, 700], variable: false },
  Calistoga: { weights: [400], variable: false },
  Calligraffitti: { weights: [400], variable: false },
  Cambay: { weights: [400, 700], variable: false },
  Cambo: { weights: [400], variable: false },
  Candal: { weights: [400], variable: false },
  Cantarell: { weights: [400, 700], variable: false },
  "Cantata One": { weights: [400], variable: false },
  "Cantora One": { weights: [400], variable: false },
  Caprasimo: { weights: [400], variable: false },
  Capriola: { weights: [400], variable: false },
  Caramel: { weights: [400], variable: false },
  Carattere: { weights: [400], variable: false },
  Cardo: { weights: [400, 700], variable: false },
  Carlito: { weights: [400, 700], variable: false },
  Carme: { weights: [400], variable: false },
  "Carrois Gothic": { weights: [400], variable: false },
  "Carrois Gothic SC": { weights: [400], variable: false },
  "Carter One": { weights: [400], variable: false },
  "Cascadia Code": { weights: [200, 300, 400, 500, 600, 700], variable: true },
  "Cascadia Mono": { weights: [200, 300, 400, 500, 600, 700], variable: true },
  Castoro: { weights: [400], variable: false },
  "Castoro Titling": { weights: [400], variable: false },
  Catamaran: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Caudex: { weights: [400, 700], variable: false },
  Cause: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Caveat: { weights: [400, 500, 600, 700], variable: true },
  "Caveat Brush": { weights: [400], variable: false },
  "Cedarville Cursive": { weights: [400], variable: false },
  "Ceviche One": { weights: [400], variable: false },
  "Chakra Petch": { weights: [300, 400, 500, 600, 700], variable: false },
  Changa: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Changa One": { weights: [400], variable: false },
  Chango: { weights: [400], variable: false },
  "Charis SIL": { weights: [400, 700], variable: false },
  Charm: { weights: [400, 700], variable: false },
  Charmonman: { weights: [400, 700], variable: false },
  Chathura: { weights: [100, 300, 400, 700, 800], variable: false },
  "Chau Philomene One": { weights: [400], variable: false },
  "Chela One": { weights: [400], variable: false },
  "Chelsea Market": { weights: [400], variable: false },
  Chenla: { weights: [400], variable: false },
  Cherish: { weights: [400], variable: false },
  "Cherry Bomb One": { weights: [400], variable: false },
  "Cherry Cream Soda": { weights: [400], variable: false },
  "Cherry Swash": { weights: [400, 700], variable: false },
  Chewy: { weights: [400], variable: false },
  Chicle: { weights: [400], variable: false },
  Chilanka: { weights: [400], variable: false },
  "Chiron GoRound TC": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Chiron Hei HK": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Chiron Sung HK": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Chivo: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Chivo Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Chocolate Classical Sans": { weights: [400], variable: false },
  Chokokutai: { weights: [400], variable: false },
  Chonburi: { weights: [400], variable: false },
  Cinzel: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Cinzel Decorative": { weights: [400, 700, 900], variable: false },
  "Clicker Script": { weights: [400], variable: false },
  "Climate Crisis": { weights: [400], variable: false },
  Coda: { weights: [400, 800], variable: false },
  Codystar: { weights: [300, 400], variable: false },
  Coiny: { weights: [400], variable: false },
  Combo: { weights: [400], variable: false },
  Comfortaa: { weights: [300, 400, 500, 600, 700], variable: true },
  Comforter: { weights: [400], variable: false },
  "Comforter Brush": { weights: [400], variable: false },
  "Comic Neue": { weights: [300, 400, 700], variable: false },
  "Comic Relief": { weights: [400, 700], variable: false },
  "Coming Soon": { weights: [400], variable: false },
  Comme: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Commissioner: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Concert One": { weights: [400], variable: false },
  Condiment: { weights: [400], variable: false },
  Content: { weights: [400, 700], variable: false },
  "Contrail One": { weights: [400], variable: false },
  Convergence: { weights: [400], variable: false },
  Cookie: { weights: [400], variable: false },
  Copse: { weights: [400], variable: false },
  "Coral Pixels": { weights: [400], variable: false },
  Corben: { weights: [400, 700], variable: false },
  Corinthia: { weights: [400, 700], variable: false },
  Cormorant: { weights: [300, 400, 500, 600, 700], variable: true },
  "Cormorant Garamond": { weights: [300, 400, 500, 600, 700], variable: true },
  "Cormorant Infant": { weights: [300, 400, 500, 600, 700], variable: true },
  "Cormorant SC": { weights: [300, 400, 500, 600, 700], variable: false },
  "Cormorant Unicase": { weights: [300, 400, 500, 600, 700], variable: false },
  "Cormorant Upright": { weights: [300, 400, 500, 600, 700], variable: false },
  "Cossette Texte": { weights: [400, 700], variable: false },
  "Cossette Titre": { weights: [400, 700], variable: false },
  Courgette: { weights: [400], variable: false },
  "Courier Prime": { weights: [400, 700], variable: false },
  Cousine: { weights: [400, 700], variable: false },
  Coustard: { weights: [400, 900], variable: false },
  "Covered By Your Grace": { weights: [400], variable: false },
  "Crafty Girls": { weights: [400], variable: false },
  Creepster: { weights: [400], variable: false },
  "Crete Round": { weights: [400], variable: false },
  "Crimson Pro": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Crimson Text": { weights: [400, 600, 700], variable: false },
  "Croissant One": { weights: [400], variable: false },
  Crushed: { weights: [400], variable: false },
  Cuprum: { weights: [400, 500, 600, 700], variable: true },
  "Cute Font": { weights: [400], variable: false },
  Cutive: { weights: [400], variable: false },
  "Cutive Mono": { weights: [400], variable: false },
  "DM Mono": { weights: [300, 400, 500], variable: false },
  "DM Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "DM Serif Display": { weights: [400], variable: false },
  "DM Serif Text": { weights: [400], variable: false },
  "Dai Banna SIL": { weights: [300, 400, 500, 600, 700], variable: false },
  Damion: { weights: [400], variable: false },
  "Dancing Script": { weights: [400, 500, 600, 700], variable: true },
  Danfo: { weights: [400], variable: false },
  Dangrek: { weights: [400], variable: false },
  "Darker Grotesque": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Darumadrop One": { weights: [400], variable: false },
  "David Libre": { weights: [400, 500, 700], variable: false },
  "Dawning of a New Day": { weights: [400], variable: false },
  "Days One": { weights: [400], variable: false },
  Dekko: { weights: [400], variable: false },
  "Dela Gothic One": { weights: [400], variable: false },
  "Delicious Handrawn": { weights: [400], variable: false },
  Delius: { weights: [400], variable: false },
  "Delius Swash Caps": { weights: [400], variable: false },
  "Delius Unicase": { weights: [400, 700], variable: false },
  "Della Respira": { weights: [400], variable: false },
  "Denk One": { weights: [400], variable: false },
  Devonshire: { weights: [400], variable: false },
  Dhurjati: { weights: [400], variable: false },
  "Didact Gothic": { weights: [400], variable: false },
  Diphylleia: { weights: [400], variable: false },
  Diplomata: { weights: [400], variable: false },
  "Diplomata SC": { weights: [400], variable: false },
  "Do Hyeon": { weights: [400], variable: false },
  Dokdo: { weights: [400], variable: false },
  Domine: { weights: [400, 500, 600, 700], variable: true },
  "Donegal One": { weights: [400], variable: false },
  Dongle: { weights: [300, 400, 700], variable: false },
  "Doppio One": { weights: [400], variable: false },
  Dorsa: { weights: [400], variable: false },
  Dosis: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  DotGothic16: { weights: [400], variable: false },
  Doto: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Dr Sugiyama": { weights: [400], variable: false },
  "Duru Sans": { weights: [400], variable: false },
  DynaPuff: { weights: [400, 500, 600, 700], variable: true },
  Dynalight: { weights: [400], variable: false },
  "EB Garamond": { weights: [400, 500, 600, 700, 800], variable: true },
  "Eagle Lake": { weights: [400], variable: false },
  "East Sea Dokdo": { weights: [400], variable: false },
  Eater: { weights: [400], variable: false },
  Economica: { weights: [400, 700], variable: false },
  Eczar: { weights: [400, 500, 600, 700, 800], variable: true },
  "Edu AU VIC WA NT Arrows": { weights: [400, 500, 600, 700], variable: true },
  "Edu AU VIC WA NT Dots": { weights: [400, 500, 600, 700], variable: true },
  "Edu AU VIC WA NT Guides": { weights: [400, 500, 600, 700], variable: true },
  "Edu AU VIC WA NT Hand": { weights: [400, 500, 600, 700], variable: true },
  "Edu AU VIC WA NT Pre": { weights: [400, 500, 600, 700], variable: true },
  "Edu NSW ACT Cursive": { weights: [400, 500, 600, 700], variable: true },
  "Edu NSW ACT Foundation": { weights: [400, 500, 600, 700], variable: true },
  "Edu NSW ACT Hand Pre": { weights: [400, 500, 600, 700], variable: true },
  "Edu QLD Beginner": { weights: [400, 500, 600, 700], variable: true },
  "Edu QLD Hand": { weights: [400, 500, 600, 700], variable: true },
  "Edu SA Beginner": { weights: [400, 500, 600, 700], variable: true },
  "Edu SA Hand": { weights: [400, 500, 600, 700], variable: true },
  "Edu TAS Beginner": { weights: [400, 500, 600, 700], variable: true },
  "Edu VIC WA NT Beginner": { weights: [400, 500, 600, 700], variable: true },
  "Edu VIC WA NT Hand": { weights: [400, 500, 600, 700], variable: true },
  "Edu VIC WA NT Hand Pre": { weights: [400, 500, 600, 700], variable: true },
  "El Messiri": { weights: [400, 500, 600, 700], variable: true },
  Electrolize: { weights: [400], variable: false },
  "Elms Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Elsie: { weights: [400, 900], variable: false },
  "Elsie Swash Caps": { weights: [400, 900], variable: false },
  "Emblema One": { weights: [400], variable: false },
  "Emilys Candy": { weights: [400], variable: false },
  "Encode Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Encode Sans Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Encode Sans Expanded": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Encode Sans SC": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Encode Sans Semi Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Encode Sans Semi Expanded": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Engagement: { weights: [400], variable: false },
  Englebert: { weights: [400], variable: false },
  Enriqueta: { weights: [400, 500, 600, 700], variable: false },
  Ephesis: { weights: [400], variable: false },
  Epilogue: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Epunda Sans": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Epunda Slab": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Erica One": { weights: [400], variable: false },
  Esteban: { weights: [400], variable: false },
  Estonia: { weights: [400], variable: false },
  "Euphoria Script": { weights: [400], variable: false },
  Ewert: { weights: [400], variable: false },
  Exile: { weights: [400], variable: false },
  Exo: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Exo 2": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Expletus Sans": { weights: [400, 500, 600, 700], variable: true },
  Explora: { weights: [400], variable: false },
  "Faculty Glyphic": { weights: [400], variable: false },
  Fahkwang: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Familjen Grotesk": { weights: [400, 500, 600, 700], variable: true },
  "Fanwood Text": { weights: [400], variable: false },
  Farro: { weights: [300, 400, 500, 700], variable: false },
  Farsan: { weights: [400], variable: false },
  Fascinate: { weights: [400], variable: false },
  "Fascinate Inline": { weights: [400], variable: false },
  "Faster One": { weights: [400], variable: false },
  Fasthand: { weights: [400], variable: false },
  "Fauna One": { weights: [400], variable: false },
  Faustina: { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Federant: { weights: [400], variable: false },
  Federo: { weights: [400], variable: false },
  Felipa: { weights: [400], variable: false },
  Fenix: { weights: [400], variable: false },
  Festive: { weights: [400], variable: false },
  Figtree: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  "Finger Paint": { weights: [400], variable: false },
  Finlandica: { weights: [400, 500, 600, 700], variable: true },
  "Fira Code": { weights: [300, 400, 500, 600, 700], variable: true },
  "Fira Mono": { weights: [400, 500, 700], variable: false },
  "Fira Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Fira Sans Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Fira Sans Extra Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Fjalla One": { weights: [400], variable: false },
  "Fjord One": { weights: [400], variable: false },
  Flamenco: { weights: [300, 400], variable: false },
  Flavors: { weights: [400], variable: false },
  "Fleur De Leah": { weights: [400], variable: false },
  "Flow Block": { weights: [400], variable: false },
  "Flow Circular": { weights: [400], variable: false },
  "Flow Rounded": { weights: [400], variable: false },
  Foldit: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Fondamento: { weights: [400], variable: false },
  "Fontdiner Swanky": { weights: [400], variable: false },
  Forum: { weights: [400], variable: false },
  "Fragment Mono": { weights: [400], variable: false },
  "Francois One": { weights: [400], variable: false },
  "Frank Ruhl Libre": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Fraunces: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Freckle Face": { weights: [400], variable: false },
  "Fredericka the Great": { weights: [400], variable: false },
  Fredoka: { weights: [300, 400, 500, 600, 700], variable: true },
  Freehand: { weights: [400], variable: false },
  Freeman: { weights: [400], variable: false },
  Fresca: { weights: [400], variable: false },
  Frijole: { weights: [400], variable: false },
  Fruktur: { weights: [400], variable: false },
  "Fugaz One": { weights: [400], variable: false },
  Fuggles: { weights: [400], variable: false },
  "Funnel Display": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  "Funnel Sans": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Fustat: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Fuzzy Bubbles": { weights: [400, 700], variable: false },
  "GFS Didot": { weights: [400], variable: false },
  "GFS Neohellenic": { weights: [400, 700], variable: false },
  "Ga Maamli": { weights: [400], variable: false },
  Gabarito: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  Gabriela: { weights: [400], variable: false },
  Gaegu: { weights: [300, 400, 700], variable: false },
  Gafata: { weights: [400], variable: false },
  "Gajraj One": { weights: [400], variable: false },
  Galada: { weights: [400], variable: false },
  Galdeano: { weights: [400], variable: false },
  Galindo: { weights: [400], variable: false },
  "Gamja Flower": { weights: [400], variable: false },
  Gantari: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Gasoek One": { weights: [400], variable: false },
  Gayathri: { weights: [100, 400, 700], variable: false },
  Geist: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Geist Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Gelasio: { weights: [400, 500, 600, 700], variable: true },
  "Gemunu Libre": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Genos: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Gentium Book Plus": { weights: [400, 700], variable: false },
  "Gentium Plus": { weights: [400, 700], variable: false },
  Geo: { weights: [400], variable: false },
  Geologica: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Geom: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  Georama: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Geostar: { weights: [400], variable: false },
  "Geostar Fill": { weights: [400], variable: false },
  "Germania One": { weights: [400], variable: false },
  "Gideon Roman": { weights: [400], variable: false },
  Gidole: { weights: [400], variable: false },
  Gidugu: { weights: [400], variable: false },
  "Gilda Display": { weights: [400], variable: false },
  Girassol: { weights: [400], variable: false },
  "Give You Glory": { weights: [400], variable: false },
  "Glass Antiqua": { weights: [400], variable: false },
  Glegoo: { weights: [400, 700], variable: false },
  Gloock: { weights: [400], variable: false },
  "Gloria Hallelujah": { weights: [400], variable: false },
  Glory: { weights: [100, 200, 300, 400, 500, 600, 700, 800], variable: true },
  Gluten: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Goblin One": { weights: [400], variable: false },
  "Gochi Hand": { weights: [400], variable: false },
  Goldman: { weights: [400, 700], variable: false },
  "Golos Text": { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Google Sans": { weights: [400, 500, 600, 700], variable: true },
  "Google Sans Code": {
    weights: [300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Google Sans Flex": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  Gorditas: { weights: [400, 700], variable: false },
  "Gothic A1": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Gotu: { weights: [400], variable: false },
  "Goudy Bookletter 1911": { weights: [400], variable: false },
  "Gowun Batang": { weights: [400, 700], variable: false },
  "Gowun Dodum": { weights: [400], variable: false },
  Graduate: { weights: [400], variable: false },
  "Grand Hotel": { weights: [400], variable: false },
  "Grandiflora One": { weights: [400], variable: false },
  Grandstander: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Grape Nuts": { weights: [400], variable: false },
  "Gravitas One": { weights: [400], variable: false },
  "Great Vibes": { weights: [400], variable: false },
  "Grechen Fuemen": { weights: [400], variable: false },
  Grenze: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Grenze Gotisch": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Grey Qo": { weights: [400], variable: false },
  Griffy: { weights: [400], variable: false },
  Gruppo: { weights: [400], variable: false },
  Gudea: { weights: [400, 700], variable: false },
  Gugi: { weights: [400], variable: false },
  Gulzar: { weights: [400], variable: false },
  Gupter: { weights: [400, 500, 700], variable: false },
  Gurajada: { weights: [400], variable: false },
  Gwendolyn: { weights: [400, 700], variable: false },
  Habibi: { weights: [400], variable: false },
  "Hachi Maru Pop": { weights: [400], variable: false },
  Hahmlet: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Halant: { weights: [300, 400, 500, 600, 700], variable: false },
  "Hammersmith One": { weights: [400], variable: false },
  Hanalei: { weights: [400], variable: false },
  "Hanalei Fill": { weights: [400], variable: false },
  Handjet: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Handlee: { weights: [400], variable: false },
  "Hanken Grotesk": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Hanuman: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Happy Monkey": { weights: [400], variable: false },
  Harmattan: { weights: [400, 500, 600, 700], variable: false },
  "Headland One": { weights: [400], variable: false },
  "Hedvig Letters Sans": { weights: [400], variable: false },
  "Hedvig Letters Serif": { weights: [400], variable: false },
  Heebo: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Henny Penny": { weights: [400], variable: false },
  "Hepta Slab": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Herr Von Muellerhoff": { weights: [400], variable: false },
  "Hi Melody": { weights: [400], variable: false },
  "Hina Mincho": { weights: [400], variable: false },
  Hind: { weights: [300, 400, 500, 600, 700], variable: false },
  "Hind Guntur": { weights: [300, 400, 500, 600, 700], variable: false },
  "Hind Madurai": { weights: [300, 400, 500, 600, 700], variable: false },
  "Hind Mysuru": { weights: [300, 400, 500, 600, 700], variable: false },
  "Hind Siliguri": { weights: [300, 400, 500, 600, 700], variable: false },
  "Hind Vadodara": { weights: [300, 400, 500, 600, 700], variable: false },
  "Holtwood One SC": { weights: [400], variable: false },
  "Homemade Apple": { weights: [400], variable: false },
  Homenaje: { weights: [400], variable: false },
  Honk: { weights: [400], variable: false },
  "Host Grotesk": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Hubballi: { weights: [400], variable: false },
  "Hubot Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Huninn: { weights: [400], variable: false },
  Hurricane: { weights: [400], variable: false },
  "IBM Plex Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "IBM Plex Sans Arabic": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans Devanagari": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans Hebrew": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans JP": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans KR": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans Thai": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Sans Thai Looped": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IBM Plex Serif": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: false,
  },
  "IM Fell DW Pica": { weights: [400], variable: false },
  "IM Fell DW Pica SC": { weights: [400], variable: false },
  "IM Fell Double Pica": { weights: [400], variable: false },
  "IM Fell Double Pica SC": { weights: [400], variable: false },
  "IM Fell English": { weights: [400], variable: false },
  "IM Fell English SC": { weights: [400], variable: false },
  "IM Fell French Canon": { weights: [400], variable: false },
  "IM Fell French Canon SC": { weights: [400], variable: false },
  "IM Fell Great Primer": { weights: [400], variable: false },
  "IM Fell Great Primer SC": { weights: [400], variable: false },
  Iansui: { weights: [400], variable: false },
  "Ibarra Real Nova": { weights: [400, 500, 600, 700], variable: true },
  Iceberg: { weights: [400], variable: false },
  Iceland: { weights: [400], variable: false },
  Imbue: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Imperial Script": { weights: [400], variable: false },
  Imprima: { weights: [400], variable: false },
  "Inclusive Sans": { weights: [300, 400, 500, 600, 700], variable: true },
  Inconsolata: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Inder: { weights: [400], variable: false },
  "Indie Flower": { weights: [400], variable: false },
  "Ingrid Darling": { weights: [400], variable: false },
  Inika: { weights: [400, 700], variable: false },
  "Inknut Antiqua": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Inria Sans": { weights: [300, 400, 700], variable: false },
  "Inria Serif": { weights: [300, 400, 700], variable: false },
  Inspiration: { weights: [400], variable: false },
  "Instrument Sans": { weights: [400, 500, 600, 700], variable: true },
  "Instrument Serif": { weights: [400], variable: false },
  "Intel One Mono": { weights: [300, 400, 500, 600, 700], variable: true },
  Inter: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Inter Tight": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Irish Grover": { weights: [400], variable: false },
  "Island Moments": { weights: [400], variable: false },
  "Istok Web": { weights: [400, 700], variable: false },
  Italiana: { weights: [400], variable: false },
  Italianno: { weights: [400], variable: false },
  Itim: { weights: [400], variable: false },
  "Jacquard 12": { weights: [400], variable: false },
  "Jacquard 12 Charted": { weights: [400], variable: false },
  "Jacquard 24": { weights: [400], variable: false },
  "Jacquard 24 Charted": { weights: [400], variable: false },
  "Jacquarda Bastarda 9": { weights: [400], variable: false },
  "Jacquarda Bastarda 9 Charted": { weights: [400], variable: false },
  "Jacques Francois": { weights: [400], variable: false },
  "Jacques Francois Shadow": { weights: [400], variable: false },
  Jaini: { weights: [400], variable: false },
  "Jaini Purva": { weights: [400], variable: false },
  Jaldi: { weights: [400, 700], variable: false },
  Jaro: { weights: [400], variable: false },
  "Jersey 10": { weights: [400], variable: false },
  "Jersey 10 Charted": { weights: [400], variable: false },
  "Jersey 15": { weights: [400], variable: false },
  "Jersey 15 Charted": { weights: [400], variable: false },
  "Jersey 20": { weights: [400], variable: false },
  "Jersey 20 Charted": { weights: [400], variable: false },
  "Jersey 25": { weights: [400], variable: false },
  "Jersey 25 Charted": { weights: [400], variable: false },
  "JetBrains Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Jim Nightshade": { weights: [400], variable: false },
  Joan: { weights: [400], variable: false },
  "Jockey One": { weights: [400], variable: false },
  "Jolly Lodger": { weights: [400], variable: false },
  Jomhuria: { weights: [400], variable: false },
  Jomolhari: { weights: [400], variable: false },
  "Josefin Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "Josefin Slab": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Jost: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Joti One": { weights: [400], variable: false },
  Jua: { weights: [400], variable: false },
  Judson: { weights: [400, 700], variable: false },
  Julee: { weights: [400], variable: false },
  "Julius Sans One": { weights: [400], variable: false },
  Junge: { weights: [400], variable: false },
  Jura: { weights: [300, 400, 500, 600, 700], variable: true },
  "Just Another Hand": { weights: [400], variable: false },
  "Just Me Again Down Here": { weights: [400], variable: false },
  K2D: { weights: [100, 200, 300, 400, 500, 600, 700, 800], variable: false },
  Kablammo: { weights: [400], variable: false },
  Kadwa: { weights: [400, 700], variable: false },
  "Kaisei Decol": { weights: [400, 500, 700], variable: false },
  "Kaisei HarunoUmi": { weights: [400, 500, 700], variable: false },
  "Kaisei Opti": { weights: [400, 500, 700], variable: false },
  "Kaisei Tokumin": { weights: [400, 500, 700, 800], variable: false },
  Kalam: { weights: [300, 400, 700], variable: false },
  Kalnia: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  "Kalnia Glaze": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Kameron: { weights: [400, 500, 600, 700], variable: true },
  Kanchenjunga: { weights: [400, 500, 600, 700], variable: false },
  Kanit: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Kantumruy Pro": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Kapakana: { weights: [300, 400], variable: true },
  Karantina: { weights: [300, 400, 700], variable: false },
  Karla: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Karla Tamil Inclined": { weights: [400, 700], variable: false },
  "Karla Tamil Upright": { weights: [400, 700], variable: false },
  Karma: { weights: [300, 400, 500, 600, 700], variable: false },
  Katibeh: { weights: [400], variable: false },
  "Kaushan Script": { weights: [400], variable: false },
  Kavivanar: { weights: [400], variable: false },
  Kavoon: { weights: [400], variable: false },
  "Kay Pho Du": { weights: [400, 500, 600, 700], variable: false },
  "Kdam Thmor Pro": { weights: [400], variable: false },
  "Keania One": { weights: [400], variable: false },
  Kedebideri: { weights: [400, 500, 600, 700, 800, 900], variable: false },
  "Kelly Slab": { weights: [400], variable: false },
  Kenia: { weights: [400], variable: false },
  Khand: { weights: [300, 400, 500, 600, 700], variable: false },
  Khmer: { weights: [400], variable: false },
  Khula: { weights: [300, 400, 600, 700, 800], variable: false },
  Kings: { weights: [400], variable: false },
  "Kirang Haerang": { weights: [400], variable: false },
  "Kite One": { weights: [400], variable: false },
  "Kiwi Maru": { weights: [300, 400, 500], variable: false },
  "Klee One": { weights: [400, 600], variable: false },
  Knewave: { weights: [400], variable: false },
  KoHo: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  Kodchasan: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Kode Mono": { weights: [400, 500, 600, 700], variable: true },
  "Koh Santepheap": { weights: [100, 300, 400, 700, 900], variable: false },
  "Kolker Brush": { weights: [400], variable: false },
  "Konkhmer Sleokchher": { weights: [400], variable: false },
  Kosugi: { weights: [400], variable: false },
  "Kosugi Maru": { weights: [400], variable: false },
  "Kotta One": { weights: [400], variable: false },
  Koulen: { weights: [400], variable: false },
  Kranky: { weights: [400], variable: false },
  Kreon: { weights: [300, 400, 500, 600, 700], variable: true },
  Kristi: { weights: [400], variable: false },
  "Krona One": { weights: [400], variable: false },
  Krub: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  Kufam: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Kulim Park": { weights: [200, 300, 400, 600, 700], variable: false },
  "Kumar One": { weights: [400], variable: false },
  "Kumar One Outline": { weights: [400], variable: false },
  "Kumbh Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Kurale: { weights: [400], variable: false },
  "LXGW Marker Gothic": { weights: [400], variable: false },
  "LXGW WenKai Mono TC": { weights: [300, 400, 700], variable: false },
  "LXGW WenKai TC": { weights: [300, 400, 700], variable: false },
  "La Belle Aurore": { weights: [400], variable: false },
  Labrada: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Lacquer: { weights: [400], variable: false },
  Laila: { weights: [300, 400, 500, 600, 700], variable: false },
  "Lakki Reddy": { weights: [400], variable: false },
  Lalezar: { weights: [400], variable: false },
  Lancelot: { weights: [400], variable: false },
  Langar: { weights: [400], variable: false },
  Lateef: { weights: [200, 300, 400, 500, 600, 700, 800], variable: false },
  Lato: { weights: [100, 300, 400, 700, 900], variable: false },
  "Lavishly Yours": { weights: [400], variable: false },
  "League Gothic": { weights: [400], variable: false },
  "League Script": { weights: [400], variable: false },
  "League Spartan": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Leckerli One": { weights: [400], variable: false },
  Ledger: { weights: [400], variable: false },
  Lekton: { weights: [400, 700], variable: false },
  Lemon: { weights: [400], variable: false },
  Lemonada: { weights: [300, 400, 500, 600, 700], variable: true },
  Lexend: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Deca": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Exa": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Giga": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Mega": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Peta": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Tera": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Lexend Zetta": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Libertinus Keyboard": { weights: [400], variable: false },
  "Libertinus Math": { weights: [400], variable: false },
  "Libertinus Mono": { weights: [400], variable: false },
  "Libertinus Sans": { weights: [400, 700], variable: false },
  "Libertinus Serif": { weights: [400, 600, 700], variable: false },
  "Libertinus Serif Display": { weights: [400], variable: false },
  "Libre Barcode 128": { weights: [400], variable: false },
  "Libre Barcode 128 Text": { weights: [400], variable: false },
  "Libre Barcode 39": { weights: [400], variable: false },
  "Libre Barcode 39 Extended": { weights: [400], variable: false },
  "Libre Barcode 39 Extended Text": { weights: [400], variable: false },
  "Libre Barcode 39 Text": { weights: [400], variable: false },
  "Libre Barcode EAN13 Text": { weights: [400], variable: false },
  "Libre Baskerville": { weights: [400, 500, 600, 700], variable: true },
  "Libre Bodoni": { weights: [400, 500, 600, 700], variable: true },
  "Libre Caslon Display": { weights: [400], variable: false },
  "Libre Caslon Text": { weights: [400, 700], variable: false },
  "Libre Franklin": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Licorice: { weights: [400], variable: false },
  "Life Savers": { weights: [400, 700, 800], variable: false },
  Lilex: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  "Lilita One": { weights: [400], variable: false },
  "Lily Script One": { weights: [400], variable: false },
  Limelight: { weights: [400], variable: false },
  "Linden Hill": { weights: [400], variable: false },
  Linefont: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Lisu Bosa": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Liter: { weights: [400], variable: false },
  Literata: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Liu Jian Mao Cao": { weights: [400], variable: false },
  Livvic: {
    weights: [100, 200, 300, 400, 500, 600, 700, 900],
    variable: false,
  },
  Lobster: { weights: [400], variable: false },
  "Lobster Two": { weights: [400, 700], variable: false },
  "Londrina Outline": { weights: [400], variable: false },
  "Londrina Shadow": { weights: [400], variable: false },
  "Londrina Sketch": { weights: [400], variable: false },
  "Londrina Solid": { weights: [100, 300, 400, 900], variable: false },
  "Long Cang": { weights: [400], variable: false },
  Lora: { weights: [400, 500, 600, 700], variable: true },
  "Love Light": { weights: [400], variable: false },
  "Love Ya Like A Sister": { weights: [400], variable: false },
  "Loved by the King": { weights: [400], variable: false },
  "Lovers Quarrel": { weights: [400], variable: false },
  "Luckiest Guy": { weights: [400], variable: false },
  Lugrasimo: { weights: [400], variable: false },
  Lumanosimo: { weights: [400], variable: false },
  Lunasima: { weights: [400, 700], variable: false },
  Lusitana: { weights: [400, 700], variable: false },
  Lustria: { weights: [400], variable: false },
  "Luxurious Roman": { weights: [400], variable: false },
  "Luxurious Script": { weights: [400], variable: false },
  "M PLUS 1": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "M PLUS 1 Code": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "M PLUS 1p": {
    weights: [100, 300, 400, 500, 700, 800, 900],
    variable: false,
  },
  "M PLUS 2": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "M PLUS Code Latin": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "M PLUS Rounded 1c": {
    weights: [100, 300, 400, 500, 700, 800, 900],
    variable: false,
  },
  "Ma Shan Zheng": { weights: [400], variable: false },
  Macondo: { weights: [400], variable: false },
  "Macondo Swash Caps": { weights: [400], variable: false },
  Mada: { weights: [200, 300, 400, 500, 600, 700, 800, 900], variable: true },
  "Madimi One": { weights: [400], variable: false },
  Magra: { weights: [400, 700], variable: false },
  "Maiden Orange": { weights: [400], variable: false },
  Maitree: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Major Mono Display": { weights: [400], variable: false },
  Mako: { weights: [400], variable: false },
  Mali: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  Mallanna: { weights: [400], variable: false },
  Maname: { weights: [400], variable: false },
  Mandali: { weights: [400], variable: false },
  Manjari: { weights: [100, 400, 700], variable: false },
  Manrope: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  Mansalva: { weights: [400], variable: false },
  Manuale: { weights: [300, 400, 500, 600, 700, 800], variable: true },
  "Manufacturing Consent": { weights: [400], variable: false },
  Marcellus: { weights: [400], variable: false },
  "Marcellus SC": { weights: [400], variable: false },
  "Marck Script": { weights: [400], variable: false },
  Margarine: { weights: [400], variable: false },
  Marhey: { weights: [300, 400, 500, 600, 700], variable: true },
  "Markazi Text": { weights: [400, 500, 600, 700], variable: true },
  "Marko One": { weights: [400], variable: false },
  Marmelad: { weights: [400], variable: false },
  Martel: { weights: [200, 300, 400, 600, 700, 800, 900], variable: false },
  "Martel Sans": {
    weights: [200, 300, 400, 600, 700, 800, 900],
    variable: false,
  },
  "Martian Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Marvel: { weights: [400, 700], variable: false },
  Matangi: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  Mate: { weights: [400], variable: false },
  "Mate SC": { weights: [400], variable: false },
  Matemasie: { weights: [400], variable: false },
  "Maven Pro": { weights: [400, 500, 600, 700, 800, 900], variable: true },
  McLaren: { weights: [400], variable: false },
  "Mea Culpa": { weights: [400], variable: false },
  Meddon: { weights: [400], variable: false },
  MedievalSharp: { weights: [400], variable: false },
  "Medula One": { weights: [400], variable: false },
  "Meera Inimai": { weights: [400], variable: false },
  Megrim: { weights: [400], variable: false },
  "Meie Script": { weights: [400], variable: false },
  Menbere: { weights: [100, 200, 300, 400, 500, 600, 700], variable: true },
  "Meow Script": { weights: [400], variable: false },
  Merienda: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  Merriweather: {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Merriweather Sans": {
    weights: [300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Metal: { weights: [400], variable: false },
  "Metal Mania": { weights: [400], variable: false },
  Metamorphous: { weights: [400], variable: false },
  Metrophobic: { weights: [400], variable: false },
  Michroma: { weights: [400], variable: false },
  "Micro 5": { weights: [400], variable: false },
  "Micro 5 Charted": { weights: [400], variable: false },
  Milonga: { weights: [400], variable: false },
  Miltonian: { weights: [400], variable: false },
  "Miltonian Tattoo": { weights: [400], variable: false },
  Mina: { weights: [400, 700], variable: false },
  Mingzat: { weights: [400], variable: false },
  Miniver: { weights: [400], variable: false },
  "Miriam Libre": { weights: [400, 500, 600, 700], variable: true },
  Mirza: { weights: [400, 500, 600, 700], variable: false },
  "Miss Fajardose": { weights: [400], variable: false },
  Mitr: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Mochiy Pop One": { weights: [400], variable: false },
  "Mochiy Pop P One": { weights: [400], variable: false },
  Modak: { weights: [400], variable: false },
  "Modern Antiqua": { weights: [400], variable: false },
  Moderustic: { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Mogra: { weights: [400], variable: false },
  Mohave: { weights: [300, 400, 500, 600, 700], variable: true },
  "Moirai One": { weights: [400], variable: false },
  Molengo: { weights: [400], variable: false },
  Molle: { weights: [400], variable: false },
  "Momo Signature": { weights: [400], variable: false },
  "Momo Trust Display": { weights: [400], variable: false },
  "Momo Trust Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Mona Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Monda: { weights: [400, 500, 600, 700], variable: true },
  Monofett: { weights: [400], variable: false },
  Monomakh: { weights: [400], variable: false },
  "Monomaniac One": { weights: [400], variable: false },
  Monoton: { weights: [400], variable: false },
  "Monsieur La Doulaise": { weights: [400], variable: false },
  Montaga: { weights: [400], variable: false },
  "Montagu Slab": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  MonteCarlo: { weights: [400], variable: false },
  Montez: { weights: [400], variable: false },
  Montserrat: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Montserrat Alternates": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Montserrat Underline": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Moo Lah Lah": { weights: [400], variable: false },
  Mooli: { weights: [400], variable: false },
  "Moon Dance": { weights: [400], variable: false },
  Moul: { weights: [400], variable: false },
  Moulpali: { weights: [400], variable: false },
  "Mountains of Christmas": { weights: [400, 700], variable: false },
  "Mouse Memoirs": { weights: [400], variable: false },
  "Mozilla Headline": {
    weights: [200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "Mozilla Text": { weights: [200, 300, 400, 500, 600, 700], variable: true },
  "Mr Bedfort": { weights: [400], variable: false },
  "Mr Dafoe": { weights: [400], variable: false },
  "Mr De Haviland": { weights: [400], variable: false },
  "Mrs Saint Delafield": { weights: [400], variable: false },
  "Mrs Sheppards": { weights: [400], variable: false },
  "Ms Madi": { weights: [400], variable: false },
  Mukta: { weights: [200, 300, 400, 500, 600, 700, 800], variable: false },
  "Mukta Mahee": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: false,
  },
  "Mukta Malar": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: false,
  },
  "Mukta Vaani": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: false,
  },
  Mulish: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  Murecho: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  MuseoModerno: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "My Soul": { weights: [400], variable: false },
  Mynerve: { weights: [400], variable: false },
  "Mystery Quest": { weights: [400], variable: false },
  NTR: { weights: [400], variable: false },
  Nabla: { weights: [400], variable: false },
  Namdhinggo: { weights: [400, 500, 600, 700, 800], variable: false },
  "Nanum Brush Script": { weights: [400], variable: false },
  "Nanum Gothic": { weights: [400, 700, 800], variable: false },
  "Nanum Gothic Coding": { weights: [400, 700], variable: false },
  "Nanum Myeongjo": { weights: [400, 700, 800], variable: false },
  "Nanum Pen Script": { weights: [400], variable: false },
  Narnoor: { weights: [400, 500, 600, 700, 800], variable: false },
  "Nata Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "National Park": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Neonderthaw: { weights: [400], variable: false },
  "Nerko One": { weights: [400], variable: false },
  Neucha: { weights: [400], variable: false },
  Neuton: { weights: [200, 300, 400, 700, 800], variable: false },
  "New Amsterdam": { weights: [400], variable: false },
  "New Rocker": { weights: [400], variable: false },
  "New Tegomin": { weights: [400], variable: false },
  "News Cycle": { weights: [400, 700], variable: false },
  Newsreader: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  Niconne: { weights: [400], variable: false },
  Niramit: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Nixie One": { weights: [400], variable: false },
  Nobile: { weights: [400, 500, 700], variable: false },
  Nokora: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Norican: { weights: [400], variable: false },
  Nosifer: { weights: [400], variable: false },
  Notable: { weights: [400], variable: false },
  "Nothing You Could Do": { weights: [400], variable: false },
  "Noticia Text": { weights: [400, 700], variable: false },
  "Noto Color Emoji": { weights: [400], variable: false },
  "Noto Emoji": { weights: [300, 400, 500, 600, 700], variable: true },
  "Noto Kufi Arabic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Music": { weights: [400], variable: false },
  "Noto Naskh Arabic": { weights: [400, 500, 600, 700], variable: true },
  "Noto Nastaliq Urdu": { weights: [400, 500, 600, 700], variable: true },
  "Noto Rashi Hebrew": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Adlam": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Adlam Unjoined": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Anatolian Hieroglyphs": { weights: [400], variable: false },
  "Noto Sans Arabic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Armenian": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Avestan": { weights: [400], variable: false },
  "Noto Sans Balinese": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Bamum": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Bassa Vah": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Batak": { weights: [400], variable: false },
  "Noto Sans Bengali": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Bhaiksuki": { weights: [400], variable: false },
  "Noto Sans Brahmi": { weights: [400], variable: false },
  "Noto Sans Buginese": { weights: [400], variable: false },
  "Noto Sans Buhid": { weights: [400], variable: false },
  "Noto Sans Canadian Aboriginal": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Carian": { weights: [400], variable: false },
  "Noto Sans Caucasian Albanian": { weights: [400], variable: false },
  "Noto Sans Chakma": { weights: [400], variable: false },
  "Noto Sans Cham": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Cherokee": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Chorasmian": { weights: [400], variable: false },
  "Noto Sans Coptic": { weights: [400], variable: false },
  "Noto Sans Cuneiform": { weights: [400], variable: false },
  "Noto Sans Cypriot": { weights: [400], variable: false },
  "Noto Sans Cypro Minoan": { weights: [400], variable: false },
  "Noto Sans Deseret": { weights: [400], variable: false },
  "Noto Sans Devanagari": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Display": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Duployan": { weights: [400, 700], variable: false },
  "Noto Sans Egyptian Hieroglyphs": { weights: [400], variable: false },
  "Noto Sans Elbasan": { weights: [400], variable: false },
  "Noto Sans Elymaic": { weights: [400], variable: false },
  "Noto Sans Ethiopic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Georgian": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Glagolitic": { weights: [400], variable: false },
  "Noto Sans Gothic": { weights: [400], variable: false },
  "Noto Sans Grantha": { weights: [400], variable: false },
  "Noto Sans Gujarati": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Gunjala Gondi": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Gurmukhi": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans HK": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Hanifi Rohingya": {
    weights: [400, 500, 600, 700],
    variable: true,
  },
  "Noto Sans Hanunoo": { weights: [400], variable: false },
  "Noto Sans Hatran": { weights: [400], variable: false },
  "Noto Sans Hebrew": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Imperial Aramaic": { weights: [400], variable: false },
  "Noto Sans Indic Siyaq Numbers": { weights: [400], variable: false },
  "Noto Sans Inscriptional Pahlavi": { weights: [400], variable: false },
  "Noto Sans Inscriptional Parthian": { weights: [400], variable: false },
  "Noto Sans JP": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Javanese": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans KR": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Kaithi": { weights: [400], variable: false },
  "Noto Sans Kannada": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Kawi": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Kayah Li": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Kharoshthi": { weights: [400], variable: false },
  "Noto Sans Khmer": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Khojki": { weights: [400], variable: false },
  "Noto Sans Khudawadi": { weights: [400], variable: false },
  "Noto Sans Lao": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Lao Looped": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Lepcha": { weights: [400], variable: false },
  "Noto Sans Limbu": { weights: [400], variable: false },
  "Noto Sans Linear A": { weights: [400], variable: false },
  "Noto Sans Linear B": { weights: [400], variable: false },
  "Noto Sans Lisu": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Lycian": { weights: [400], variable: false },
  "Noto Sans Lydian": { weights: [400], variable: false },
  "Noto Sans Mahajani": { weights: [400], variable: false },
  "Noto Sans Malayalam": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Mandaic": { weights: [400], variable: false },
  "Noto Sans Manichaean": { weights: [400], variable: false },
  "Noto Sans Marchen": { weights: [400], variable: false },
  "Noto Sans Masaram Gondi": { weights: [400], variable: false },
  "Noto Sans Math": { weights: [400], variable: false },
  "Noto Sans Mayan Numerals": { weights: [400], variable: false },
  "Noto Sans Medefaidrin": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Meetei Mayek": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Mende Kikakui": { weights: [400], variable: false },
  "Noto Sans Meroitic": { weights: [400], variable: false },
  "Noto Sans Miao": { weights: [400], variable: false },
  "Noto Sans Modi": { weights: [400], variable: false },
  "Noto Sans Mongolian": { weights: [400], variable: false },
  "Noto Sans Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Mro": { weights: [400], variable: false },
  "Noto Sans Multani": { weights: [400], variable: false },
  "Noto Sans Myanmar": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Noto Sans NKo": { weights: [400], variable: false },
  "Noto Sans NKo Unjoined": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Nabataean": { weights: [400], variable: false },
  "Noto Sans Nag Mundari": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Nandinagari": { weights: [400], variable: false },
  "Noto Sans New Tai Lue": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Newa": { weights: [400], variable: false },
  "Noto Sans Nushu": { weights: [400], variable: false },
  "Noto Sans Ogham": { weights: [400], variable: false },
  "Noto Sans Ol Chiki": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Old Hungarian": { weights: [400], variable: false },
  "Noto Sans Old Italic": { weights: [400], variable: false },
  "Noto Sans Old North Arabian": { weights: [400], variable: false },
  "Noto Sans Old Permic": { weights: [400], variable: false },
  "Noto Sans Old Persian": { weights: [400], variable: false },
  "Noto Sans Old Sogdian": { weights: [400], variable: false },
  "Noto Sans Old South Arabian": { weights: [400], variable: false },
  "Noto Sans Old Turkic": { weights: [400], variable: false },
  "Noto Sans Oriya": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Osage": { weights: [400], variable: false },
  "Noto Sans Osmanya": { weights: [400], variable: false },
  "Noto Sans Pahawh Hmong": { weights: [400], variable: false },
  "Noto Sans Palmyrene": { weights: [400], variable: false },
  "Noto Sans Pau Cin Hau": { weights: [400], variable: false },
  "Noto Sans PhagsPa": { weights: [400], variable: false },
  "Noto Sans Phoenician": { weights: [400], variable: false },
  "Noto Sans Psalter Pahlavi": { weights: [400], variable: false },
  "Noto Sans Rejang": { weights: [400], variable: false },
  "Noto Sans Runic": { weights: [400], variable: false },
  "Noto Sans SC": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Samaritan": { weights: [400], variable: false },
  "Noto Sans Saurashtra": { weights: [400], variable: false },
  "Noto Sans Sharada": { weights: [400], variable: false },
  "Noto Sans Shavian": { weights: [400], variable: false },
  "Noto Sans Siddham": { weights: [400], variable: false },
  "Noto Sans SignWriting": { weights: [400], variable: false },
  "Noto Sans Sinhala": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Sogdian": { weights: [400], variable: false },
  "Noto Sans Sora Sompeng": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Soyombo": { weights: [400], variable: false },
  "Noto Sans Sundanese": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Sunuwar": { weights: [400], variable: false },
  "Noto Sans Syloti Nagri": { weights: [400], variable: false },
  "Noto Sans Symbols": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Symbols 2": { weights: [400], variable: false },
  "Noto Sans Syriac": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Syriac Eastern": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Syriac Western": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans TC": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Tagalog": { weights: [400], variable: false },
  "Noto Sans Tagbanwa": { weights: [400], variable: false },
  "Noto Sans Tai Le": { weights: [400], variable: false },
  "Noto Sans Tai Tham": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Tai Viet": { weights: [400], variable: false },
  "Noto Sans Takri": { weights: [400], variable: false },
  "Noto Sans Tamil": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Tamil Supplement": { weights: [400], variable: false },
  "Noto Sans Tangsa": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Telugu": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Thaana": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Thai": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Thai Looped": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Sans Tifinagh": { weights: [400], variable: false },
  "Noto Sans Tirhuta": { weights: [400], variable: false },
  "Noto Sans Ugaritic": { weights: [400], variable: false },
  "Noto Sans Vai": { weights: [400], variable: false },
  "Noto Sans Vithkuqi": { weights: [400, 500, 600, 700], variable: true },
  "Noto Sans Wancho": { weights: [400], variable: false },
  "Noto Sans Warang Citi": { weights: [400], variable: false },
  "Noto Sans Yi": { weights: [400], variable: false },
  "Noto Sans Zanabazar Square": { weights: [400], variable: false },
  "Noto Serif": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Ahom": { weights: [400], variable: false },
  "Noto Serif Armenian": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Balinese": { weights: [400], variable: false },
  "Noto Serif Bengali": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Devanagari": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Display": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Dives Akuru": { weights: [400], variable: false },
  "Noto Serif Dogra": { weights: [400], variable: false },
  "Noto Serif Ethiopic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Georgian": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Grantha": { weights: [400], variable: false },
  "Noto Serif Gujarati": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Gurmukhi": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif HK": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Hebrew": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Hentaigana": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif JP": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif KR": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Kannada": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Khitan Small Script": { weights: [400], variable: false },
  "Noto Serif Khmer": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Khojki": { weights: [400, 500, 600, 700], variable: true },
  "Noto Serif Lao": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Makasar": { weights: [400], variable: false },
  "Noto Serif Malayalam": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Myanmar": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Noto Serif NP Hmong": { weights: [400, 500, 600, 700], variable: true },
  "Noto Serif Old Uyghur": { weights: [400], variable: false },
  "Noto Serif Oriya": { weights: [400, 500, 600, 700], variable: true },
  "Noto Serif Ottoman Siyaq": { weights: [400], variable: false },
  "Noto Serif SC": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Sinhala": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif TC": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Tamil": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Tangut": { weights: [400], variable: false },
  "Noto Serif Telugu": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Thai": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Tibetan": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Noto Serif Todhri": { weights: [400], variable: false },
  "Noto Serif Toto": { weights: [400, 500, 600, 700], variable: true },
  "Noto Serif Vithkuqi": { weights: [400, 500, 600, 700], variable: true },
  "Noto Serif Yezidi": { weights: [400, 500, 600, 700], variable: true },
  "Noto Traditional Nushu": {
    weights: [300, 400, 500, 600, 700],
    variable: true,
  },
  "Noto Znamenny Musical Notation": { weights: [400], variable: false },
  "Nova Cut": { weights: [400], variable: false },
  "Nova Flat": { weights: [400], variable: false },
  "Nova Mono": { weights: [400], variable: false },
  "Nova Oval": { weights: [400], variable: false },
  "Nova Round": { weights: [400], variable: false },
  "Nova Script": { weights: [400], variable: false },
  "Nova Slim": { weights: [400], variable: false },
  "Nova Square": { weights: [400], variable: false },
  Numans: { weights: [400], variable: false },
  Nunito: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Nunito Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Nuosu SIL": { weights: [400], variable: false },
  "Odibee Sans": { weights: [400], variable: false },
  "Odor Mean Chey": { weights: [400], variable: false },
  Offside: { weights: [400], variable: false },
  Oi: { weights: [400], variable: false },
  Ojuju: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Old Standard TT": { weights: [400, 700], variable: false },
  Oldenburg: { weights: [400], variable: false },
  Ole: { weights: [400], variable: false },
  "Oleo Script": { weights: [400, 700], variable: false },
  "Oleo Script Swash Caps": { weights: [400, 700], variable: false },
  Onest: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Oooh Baby": { weights: [400], variable: false },
  "Open Sans": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Oranienbaum: { weights: [400], variable: false },
  Orbit: { weights: [400], variable: false },
  Orbitron: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  Oregano: { weights: [400], variable: false },
  "Orelega One": { weights: [400], variable: false },
  Orienta: { weights: [400], variable: false },
  "Original Surfer": { weights: [400], variable: false },
  Oswald: { weights: [200, 300, 400, 500, 600, 700], variable: true },
  Outfit: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Over the Rainbow": { weights: [400], variable: false },
  Overlock: { weights: [400, 700, 900], variable: false },
  "Overlock SC": { weights: [400], variable: false },
  Overpass: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Overpass Mono": { weights: [300, 400, 500, 600, 700], variable: true },
  Ovo: { weights: [400], variable: false },
  Oxanium: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  Oxygen: { weights: [300, 400, 700], variable: false },
  "Oxygen Mono": { weights: [400], variable: false },
  "PT Mono": { weights: [400], variable: false },
  "PT Sans": { weights: [400, 700], variable: false },
  "PT Sans Caption": { weights: [400, 700], variable: false },
  "PT Sans Narrow": { weights: [400, 700], variable: false },
  "PT Serif": { weights: [400, 700], variable: false },
  "PT Serif Caption": { weights: [400], variable: false },
  Pacifico: { weights: [400], variable: false },
  Padauk: { weights: [400, 700], variable: false },
  "Padyakke Expanded One": { weights: [400], variable: false },
  Palanquin: { weights: [100, 200, 300, 400, 500, 600, 700], variable: false },
  "Palanquin Dark": { weights: [400, 500, 600, 700], variable: false },
  "Palette Mosaic": { weights: [400], variable: false },
  Pangolin: { weights: [400], variable: false },
  Paprika: { weights: [400], variable: false },
  Parastoo: { weights: [400, 500, 600, 700], variable: true },
  Parisienne: { weights: [400], variable: false },
  Parkinsans: { weights: [300, 400, 500, 600, 700, 800], variable: true },
  "Passero One": { weights: [400], variable: false },
  "Passion One": { weights: [400, 700, 900], variable: false },
  "Passions Conflict": { weights: [400], variable: false },
  "Pathway Extreme": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Pathway Gothic One": { weights: [400], variable: false },
  "Patrick Hand": { weights: [400], variable: false },
  "Patrick Hand SC": { weights: [400], variable: false },
  Pattaya: { weights: [400], variable: false },
  "Patua One": { weights: [400], variable: false },
  Pavanam: { weights: [400], variable: false },
  "Paytone One": { weights: [400], variable: false },
  Peddana: { weights: [400], variable: false },
  Peralta: { weights: [400], variable: false },
  "Permanent Marker": { weights: [400], variable: false },
  Petemoss: { weights: [400], variable: false },
  "Petit Formal Script": { weights: [400], variable: false },
  Petrona: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Phetsarath: { weights: [400, 700], variable: false },
  Philosopher: { weights: [400, 700], variable: false },
  Phudu: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  Piazzolla: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Piedra: { weights: [400], variable: false },
  "Pinyon Script": { weights: [400], variable: false },
  "Pirata One": { weights: [400], variable: false },
  "Pixelify Sans": { weights: [400, 500, 600, 700], variable: true },
  Plaster: { weights: [400], variable: false },
  Platypi: { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Play: { weights: [400, 700], variable: false },
  Playball: { weights: [400], variable: false },
  Playfair: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  "Playfair Display": {
    weights: [400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Playfair Display SC": { weights: [400, 700, 900], variable: false },
  "Playpen Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Playpen Sans Arabic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Playpen Sans Deva": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Playpen Sans Hebrew": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Playpen Sans Thai": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Playwrite AR": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AR Guides": { weights: [400], variable: false },
  "Playwrite AT": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AT Guides": { weights: [400], variable: false },
  "Playwrite AU NSW": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AU NSW Guides": { weights: [400], variable: false },
  "Playwrite AU QLD": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AU QLD Guides": { weights: [400], variable: false },
  "Playwrite AU SA": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AU SA Guides": { weights: [400], variable: false },
  "Playwrite AU TAS": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AU TAS Guides": { weights: [400], variable: false },
  "Playwrite AU VIC": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite AU VIC Guides": { weights: [400], variable: false },
  "Playwrite BE VLG": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite BE VLG Guides": { weights: [400], variable: false },
  "Playwrite BE WAL": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite BE WAL Guides": { weights: [400], variable: false },
  "Playwrite BR": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite BR Guides": { weights: [400], variable: false },
  "Playwrite CA": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite CA Guides": { weights: [400], variable: false },
  "Playwrite CL": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite CL Guides": { weights: [400], variable: false },
  "Playwrite CO": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite CO Guides": { weights: [400], variable: false },
  "Playwrite CU": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite CU Guides": { weights: [400], variable: false },
  "Playwrite CZ": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite CZ Guides": { weights: [400], variable: false },
  "Playwrite DE Grund": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DE Grund Guides": { weights: [400], variable: false },
  "Playwrite DE LA": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DE LA Guides": { weights: [400], variable: false },
  "Playwrite DE SAS": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DE SAS Guides": { weights: [400], variable: false },
  "Playwrite DE VA": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DE VA Guides": { weights: [400], variable: false },
  "Playwrite DK Loopet": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DK Loopet Guides": { weights: [400], variable: false },
  "Playwrite DK Uloopet": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite DK Uloopet Guides": { weights: [400], variable: false },
  "Playwrite ES": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite ES Deco": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite ES Deco Guides": { weights: [400], variable: false },
  "Playwrite ES Guides": { weights: [400], variable: false },
  "Playwrite FR Moderne": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite FR Moderne Guides": { weights: [400], variable: false },
  "Playwrite FR Trad": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite FR Trad Guides": { weights: [400], variable: false },
  "Playwrite GB J": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite GB J Guides": { weights: [400], variable: false },
  "Playwrite GB S": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite GB S Guides": { weights: [400], variable: false },
  "Playwrite HR": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite HR Guides": { weights: [400], variable: false },
  "Playwrite HR Lijeva": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite HR Lijeva Guides": { weights: [400], variable: false },
  "Playwrite HU": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite HU Guides": { weights: [400], variable: false },
  "Playwrite ID": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite ID Guides": { weights: [400], variable: false },
  "Playwrite IE": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite IE Guides": { weights: [400], variable: false },
  "Playwrite IN": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite IN Guides": { weights: [400], variable: false },
  "Playwrite IS": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite IS Guides": { weights: [400], variable: false },
  "Playwrite IT Moderna": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite IT Moderna Guides": { weights: [400], variable: false },
  "Playwrite IT Trad": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite IT Trad Guides": { weights: [400], variable: false },
  "Playwrite MX": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite MX Guides": { weights: [400], variable: false },
  "Playwrite NG Modern": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite NG Modern Guides": { weights: [400], variable: false },
  "Playwrite NL": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite NL Guides": { weights: [400], variable: false },
  "Playwrite NO": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite NO Guides": { weights: [400], variable: false },
  "Playwrite NZ": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite NZ Guides": { weights: [400], variable: false },
  "Playwrite PE": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite PE Guides": { weights: [400], variable: false },
  "Playwrite PL": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite PL Guides": { weights: [400], variable: false },
  "Playwrite PT": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite PT Guides": { weights: [400], variable: false },
  "Playwrite RO": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite RO Guides": { weights: [400], variable: false },
  "Playwrite SK": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite SK Guides": { weights: [400], variable: false },
  "Playwrite TZ": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite TZ Guides": { weights: [400], variable: false },
  "Playwrite US Modern": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite US Modern Guides": { weights: [400], variable: false },
  "Playwrite US Trad": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite US Trad Guides": { weights: [400], variable: false },
  "Playwrite VN": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite VN Guides": { weights: [400], variable: false },
  "Playwrite ZA": { weights: [100, 200, 300, 400], variable: true },
  "Playwrite ZA Guides": { weights: [400], variable: false },
  "Plus Jakarta Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Pochaevsk: { weights: [400], variable: false },
  Podkova: { weights: [400, 500, 600, 700, 800], variable: true },
  "Poetsen One": { weights: [400], variable: false },
  "Poiret One": { weights: [400], variable: false },
  "Poller One": { weights: [400], variable: false },
  "Poltawski Nowy": { weights: [400, 500, 600, 700], variable: true },
  Poly: { weights: [400], variable: false },
  Pompiere: { weights: [400], variable: false },
  Ponnala: { weights: [400], variable: false },
  Ponomar: { weights: [400], variable: false },
  "Pontano Sans": { weights: [300, 400, 500, 600, 700], variable: true },
  "Poor Story": { weights: [400], variable: false },
  Poppins: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Port Lligat Sans": { weights: [400], variable: false },
  "Port Lligat Slab": { weights: [400], variable: false },
  "Potta One": { weights: [400], variable: false },
  "Pragati Narrow": { weights: [400, 700], variable: false },
  Praise: { weights: [400], variable: false },
  Prata: { weights: [400], variable: false },
  Preahvihear: { weights: [400], variable: false },
  "Press Start 2P": { weights: [400], variable: false },
  Pridi: { weights: [200, 300, 400, 500, 600, 700], variable: false },
  "Princess Sofia": { weights: [400], variable: false },
  Prociono: { weights: [400], variable: false },
  Prompt: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Prosto One": { weights: [400], variable: false },
  "Protest Guerrilla": { weights: [400], variable: false },
  "Protest Revolution": { weights: [400], variable: false },
  "Protest Riot": { weights: [400], variable: false },
  "Protest Strike": { weights: [400], variable: false },
  "Proza Libre": { weights: [400, 500, 600, 700, 800], variable: false },
  "Public Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Puppies Play": { weights: [400], variable: false },
  Puritan: { weights: [400, 700], variable: false },
  "Purple Purse": { weights: [400], variable: false },
  Qahiri: { weights: [400], variable: false },
  Quando: { weights: [400], variable: false },
  Quantico: { weights: [400, 700], variable: false },
  Quattrocento: { weights: [400, 700], variable: false },
  "Quattrocento Sans": { weights: [400, 700], variable: false },
  Questrial: { weights: [400], variable: false },
  Quicksand: { weights: [300, 400, 500, 600, 700], variable: true },
  Quintessential: { weights: [400], variable: false },
  Qwigley: { weights: [400], variable: false },
  "Qwitcher Grypen": { weights: [400, 700], variable: false },
  REM: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Racing Sans One": { weights: [400], variable: false },
  "Radio Canada": { weights: [300, 400, 500, 600, 700], variable: true },
  "Radio Canada Big": { weights: [400, 500, 600, 700], variable: true },
  Radley: { weights: [400], variable: false },
  Rajdhani: { weights: [300, 400, 500, 600, 700], variable: false },
  Rakkas: { weights: [400], variable: false },
  Raleway: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Raleway Dots": { weights: [400], variable: false },
  Ramabhadra: { weights: [400], variable: false },
  Ramaraja: { weights: [400], variable: false },
  Rambla: { weights: [400, 700], variable: false },
  "Rammetto One": { weights: [400], variable: false },
  "Rampart One": { weights: [400], variable: false },
  Ranchers: { weights: [400], variable: false },
  Rancho: { weights: [400], variable: false },
  Ranga: { weights: [400, 700], variable: false },
  Rasa: { weights: [300, 400, 500, 600, 700], variable: true },
  Rationale: { weights: [400], variable: false },
  "Ravi Prakash": { weights: [400], variable: false },
  "Readex Pro": { weights: [200, 300, 400, 500, 600, 700], variable: true },
  Recursive: {
    weights: [300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Red Hat Display": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Red Hat Mono": { weights: [300, 400, 500, 600, 700], variable: true },
  "Red Hat Text": { weights: [300, 400, 500, 600, 700], variable: true },
  "Red Rose": { weights: [300, 400, 500, 600, 700], variable: true },
  Redacted: { weights: [400], variable: false },
  "Redacted Script": { weights: [300, 400, 700], variable: false },
  "Reddit Mono": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Reddit Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Reddit Sans Condensed": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Redressed: { weights: [400], variable: false },
  "Reem Kufi": { weights: [400, 500, 600, 700], variable: true },
  "Reem Kufi Fun": { weights: [400, 500, 600, 700], variable: true },
  "Reem Kufi Ink": { weights: [400], variable: false },
  "Reenie Beanie": { weights: [400], variable: false },
  "Reggae One": { weights: [400], variable: false },
  "Rethink Sans": { weights: [400, 500, 600, 700, 800], variable: true },
  Revalia: { weights: [400], variable: false },
  "Rhodium Libre": { weights: [400], variable: false },
  Ribeye: { weights: [400], variable: false },
  "Ribeye Marrow": { weights: [400], variable: false },
  Righteous: { weights: [400], variable: false },
  Risque: { weights: [400], variable: false },
  "Road Rage": { weights: [400], variable: false },
  Roboto: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Roboto Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Roboto Flex": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Roboto Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "Roboto Serif": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Roboto Slab": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Rochester: { weights: [400], variable: false },
  "Rock 3D": { weights: [400], variable: false },
  "Rock Salt": { weights: [400], variable: false },
  "RocknRoll One": { weights: [400], variable: false },
  Rokkitt: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Romanesco: { weights: [400], variable: false },
  "Ropa Sans": { weights: [400], variable: false },
  Rosario: { weights: [300, 400, 500, 600, 700], variable: true },
  Rosarivo: { weights: [400], variable: false },
  "Rouge Script": { weights: [400], variable: false },
  Rowdies: { weights: [300, 400, 700], variable: false },
  "Rozha One": { weights: [400], variable: false },
  Rubik: { weights: [300, 400, 500, 600, 700, 800, 900], variable: true },
  "Rubik 80s Fade": { weights: [400], variable: false },
  "Rubik Beastly": { weights: [400], variable: false },
  "Rubik Broken Fax": { weights: [400], variable: false },
  "Rubik Bubbles": { weights: [400], variable: false },
  "Rubik Burned": { weights: [400], variable: false },
  "Rubik Dirt": { weights: [400], variable: false },
  "Rubik Distressed": { weights: [400], variable: false },
  "Rubik Doodle Shadow": { weights: [400], variable: false },
  "Rubik Doodle Triangles": { weights: [400], variable: false },
  "Rubik Gemstones": { weights: [400], variable: false },
  "Rubik Glitch": { weights: [400], variable: false },
  "Rubik Glitch Pop": { weights: [400], variable: false },
  "Rubik Iso": { weights: [400], variable: false },
  "Rubik Lines": { weights: [400], variable: false },
  "Rubik Maps": { weights: [400], variable: false },
  "Rubik Marker Hatch": { weights: [400], variable: false },
  "Rubik Maze": { weights: [400], variable: false },
  "Rubik Microbe": { weights: [400], variable: false },
  "Rubik Mono One": { weights: [400], variable: false },
  "Rubik Moonrocks": { weights: [400], variable: false },
  "Rubik Pixels": { weights: [400], variable: false },
  "Rubik Puddles": { weights: [400], variable: false },
  "Rubik Scribble": { weights: [400], variable: false },
  "Rubik Spray Paint": { weights: [400], variable: false },
  "Rubik Storm": { weights: [400], variable: false },
  "Rubik Vinyl": { weights: [400], variable: false },
  "Rubik Wet Paint": { weights: [400], variable: false },
  Ruda: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  Rufina: { weights: [400, 700], variable: false },
  "Ruge Boogie": { weights: [400], variable: false },
  Ruluko: { weights: [400], variable: false },
  "Rum Raisin": { weights: [400], variable: false },
  "Ruslan Display": { weights: [400], variable: false },
  "Russo One": { weights: [400], variable: false },
  Ruthie: { weights: [400], variable: false },
  Ruwudu: { weights: [400, 500, 600, 700], variable: false },
  Rye: { weights: [400], variable: false },
  "STIX Two Text": { weights: [400, 500, 600, 700], variable: true },
  SUSE: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "SUSE Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Sacramento: { weights: [400], variable: false },
  Sahitya: { weights: [400, 700], variable: false },
  Sail: { weights: [400], variable: false },
  Saira: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Saira Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Saira Extra Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Saira Semi Condensed": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  "Saira Stencil One": { weights: [400], variable: false },
  Salsa: { weights: [400], variable: false },
  Sanchez: { weights: [400], variable: false },
  Sancreek: { weights: [400], variable: false },
  "Sankofa Display": { weights: [400], variable: false },
  Sansation: { weights: [300, 400, 700], variable: false },
  Sansita: { weights: [400, 700, 800, 900], variable: false },
  "Sansita Swashed": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Sarabun: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: false,
  },
  Sarala: { weights: [400, 700], variable: false },
  Sarina: { weights: [400], variable: false },
  Sarpanch: { weights: [400, 500, 600, 700, 800, 900], variable: false },
  "Sassy Frass": { weights: [400], variable: false },
  Satisfy: { weights: [400], variable: false },
  Savate: { weights: [200, 300, 400, 500, 600, 700, 800, 900], variable: true },
  "Sawarabi Gothic": { weights: [400], variable: false },
  "Sawarabi Mincho": { weights: [400], variable: false },
  Scada: { weights: [400, 700], variable: false },
  "Scheherazade New": { weights: [400, 500, 600, 700], variable: false },
  "Schibsted Grotesk": {
    weights: [400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Schoolbell: { weights: [400], variable: false },
  "Science Gothic": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Scope One": { weights: [400], variable: false },
  "Seaweed Script": { weights: [400], variable: false },
  "Secular One": { weights: [400], variable: false },
  Sedan: { weights: [400], variable: false },
  "Sedan SC": { weights: [400], variable: false },
  "Sedgwick Ave": { weights: [400], variable: false },
  "Sedgwick Ave Display": { weights: [400], variable: false },
  Sekuya: { weights: [400], variable: false },
  Sen: { weights: [400, 500, 600, 700, 800], variable: true },
  "Send Flowers": { weights: [400], variable: false },
  Sevillana: { weights: [400], variable: false },
  "Seymour One": { weights: [400], variable: false },
  "Shadows Into Light": { weights: [400], variable: false },
  "Shadows Into Light Two": { weights: [400], variable: false },
  Shafarik: { weights: [400], variable: false },
  Shalimar: { weights: [400], variable: false },
  "Shantell Sans": { weights: [300, 400, 500, 600, 700, 800], variable: true },
  Shanti: { weights: [400], variable: false },
  Share: { weights: [400, 700], variable: false },
  "Share Tech": { weights: [400], variable: false },
  "Share Tech Mono": { weights: [400], variable: false },
  "Shippori Antique": { weights: [400], variable: false },
  "Shippori Antique B1": { weights: [400], variable: false },
  "Shippori Mincho": { weights: [400, 500, 600, 700, 800], variable: false },
  "Shippori Mincho B1": { weights: [400, 500, 600, 700, 800], variable: false },
  Shizuru: { weights: [400], variable: false },
  Shojumaru: { weights: [400], variable: false },
  "Short Stack": { weights: [400], variable: false },
  Shrikhand: { weights: [400], variable: false },
  Siemreap: { weights: [400], variable: false },
  Sigmar: { weights: [400], variable: false },
  "Sigmar One": { weights: [400], variable: false },
  Signika: { weights: [300, 400, 500, 600, 700], variable: true },
  "Signika Negative": { weights: [300, 400, 500, 600, 700], variable: true },
  Silkscreen: { weights: [400, 700], variable: false },
  Simonetta: { weights: [400, 900], variable: false },
  "Single Day": { weights: [400], variable: false },
  Sintony: { weights: [400, 700], variable: false },
  "Sirin Stencil": { weights: [400], variable: false },
  Sirivennela: { weights: [400], variable: false },
  "Six Caps": { weights: [400], variable: false },
  Sixtyfour: { weights: [400], variable: false },
  "Sixtyfour Convergence": { weights: [400], variable: false },
  Skranji: { weights: [400, 700], variable: false },
  "Slabo 13px": { weights: [400], variable: false },
  "Slabo 27px": { weights: [400], variable: false },
  Slackey: { weights: [400], variable: false },
  "Slackside One": { weights: [400], variable: false },
  Smokum: { weights: [400], variable: false },
  Smooch: { weights: [400], variable: false },
  "Smooch Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Smythe: { weights: [400], variable: false },
  Sniglet: { weights: [400, 800], variable: false },
  Snippet: { weights: [400], variable: false },
  "Snowburst One": { weights: [400], variable: false },
  "Sofadi One": { weights: [400], variable: false },
  Sofia: { weights: [400], variable: false },
  "Sofia Sans": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Sofia Sans Condensed": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Sofia Sans Extra Condensed": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Sofia Sans Semi Condensed": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  Solitreo: { weights: [400], variable: false },
  Solway: { weights: [300, 400, 500, 700, 800], variable: false },
  "Sometype Mono": { weights: [400, 500, 600, 700], variable: true },
  "Song Myung": { weights: [400], variable: false },
  Sono: { weights: [200, 300, 400, 500, 600, 700, 800], variable: true },
  "Sonsie One": { weights: [400], variable: false },
  Sora: { weights: [100, 200, 300, 400, 500, 600, 700, 800], variable: true },
  "Sorts Mill Goudy": { weights: [400], variable: false },
  "Sour Gummy": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Source Code Pro": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Source Sans 3": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Source Serif 4": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Space Grotesk": { weights: [300, 400, 500, 600, 700], variable: true },
  "Space Mono": { weights: [400, 700], variable: false },
  "Special Elite": { weights: [400], variable: false },
  "Special Gothic": { weights: [400, 500, 600, 700], variable: true },
  "Special Gothic Condensed One": { weights: [400], variable: false },
  "Special Gothic Expanded One": { weights: [400], variable: false },
  Spectral: { weights: [200, 300, 400, 500, 600, 700, 800], variable: false },
  "Spectral SC": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: false,
  },
  "Spicy Rice": { weights: [400], variable: false },
  Spinnaker: { weights: [400], variable: false },
  Spirax: { weights: [400], variable: false },
  Splash: { weights: [400], variable: false },
  "Spline Sans": { weights: [300, 400, 500, 600, 700], variable: true },
  "Spline Sans Mono": { weights: [300, 400, 500, 600, 700], variable: true },
  "Squada One": { weights: [400], variable: false },
  "Square Peg": { weights: [400], variable: false },
  "Sree Krushnadevaraya": { weights: [400], variable: false },
  Sriracha: { weights: [400], variable: false },
  Srisakdi: { weights: [400, 700], variable: false },
  Staatliches: { weights: [400], variable: false },
  "Stack Sans Headline": {
    weights: [200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "Stack Sans Notch": {
    weights: [200, 300, 400, 500, 600, 700],
    variable: true,
  },
  "Stack Sans Text": {
    weights: [200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Stalemate: { weights: [400], variable: false },
  "Stalinist One": { weights: [400], variable: false },
  "Stardos Stencil": { weights: [400, 700], variable: false },
  Stick: { weights: [400], variable: false },
  "Stick No Bills": {
    weights: [200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Stint Ultra Condensed": { weights: [400], variable: false },
  "Stint Ultra Expanded": { weights: [400], variable: false },
  Stoke: { weights: [300, 400], variable: false },
  "Story Script": { weights: [400], variable: false },
  Strait: { weights: [400], variable: false },
  "Style Script": { weights: [400], variable: false },
  Stylish: { weights: [400], variable: false },
  "Sue Ellen Francisco": { weights: [400], variable: false },
  "Suez One": { weights: [400], variable: false },
  "Sulphur Point": { weights: [300, 400, 700], variable: false },
  Sumana: { weights: [400, 700], variable: false },
  Sunflower: { weights: [300, 500, 700], variable: false },
  Sunshiney: { weights: [400], variable: false },
  "Supermercado One": { weights: [400], variable: false },
  Sura: { weights: [400, 700], variable: false },
  Suranna: { weights: [400], variable: false },
  Suravaram: { weights: [400], variable: false },
  Suwannaphum: { weights: [100, 300, 400, 700, 900], variable: false },
  "Swanky and Moo Moo": { weights: [400], variable: false },
  Syncopate: { weights: [400, 700], variable: false },
  Syne: { weights: [400, 500, 600, 700, 800], variable: true },
  "Syne Mono": { weights: [400], variable: false },
  "Syne Tactile": { weights: [400], variable: false },
  "TASA Explorer": { weights: [400, 500, 600, 700, 800], variable: true },
  "TASA Orbiter": { weights: [400, 500, 600, 700, 800], variable: true },
  "Tac One": { weights: [400], variable: false },
  Tagesschrift: { weights: [400], variable: false },
  "Tai Heritage Pro": { weights: [400, 700], variable: false },
  Tajawal: { weights: [200, 300, 400, 500, 700, 800, 900], variable: false },
  Tangerine: { weights: [400, 700], variable: false },
  Tapestry: { weights: [400], variable: false },
  Taprom: { weights: [400], variable: false },
  Tauri: { weights: [400], variable: false },
  Taviraj: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Teachers: { weights: [400, 500, 600, 700, 800], variable: true },
  Teko: { weights: [300, 400, 500, 600, 700], variable: true },
  Tektur: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  Telex: { weights: [400], variable: false },
  "Tenali Ramakrishna": { weights: [400], variable: false },
  "Tenor Sans": { weights: [400], variable: false },
  "Text Me One": { weights: [400], variable: false },
  Texturina: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Thasadith: { weights: [400, 700], variable: false },
  "The Girl Next Door": { weights: [400], variable: false },
  "The Nautigal": { weights: [400, 700], variable: false },
  Tienne: { weights: [400, 700, 900], variable: false },
  "TikTok Sans": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Tillana: { weights: [400, 500, 600, 700, 800], variable: false },
  "Tilt Neon": { weights: [400], variable: false },
  "Tilt Prism": { weights: [400], variable: false },
  "Tilt Warp": { weights: [400], variable: false },
  Timmana: { weights: [400], variable: false },
  Tinos: { weights: [400, 700], variable: false },
  Tiny5: { weights: [400], variable: false },
  "Tiro Bangla": { weights: [400], variable: false },
  "Tiro Devanagari Hindi": { weights: [400], variable: false },
  "Tiro Devanagari Marathi": { weights: [400], variable: false },
  "Tiro Devanagari Sanskrit": { weights: [400], variable: false },
  "Tiro Gurmukhi": { weights: [400], variable: false },
  "Tiro Kannada": { weights: [400], variable: false },
  "Tiro Tamil": { weights: [400], variable: false },
  "Tiro Telugu": { weights: [400], variable: false },
  Tirra: { weights: [400, 500, 600, 700, 800, 900], variable: false },
  "Titan One": { weights: [400], variable: false },
  "Titillium Web": { weights: [200, 300, 400, 600, 700, 900], variable: false },
  Tomorrow: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Tourney: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Trade Winds": { weights: [400], variable: false },
  "Train One": { weights: [400], variable: false },
  Triodion: { weights: [400], variable: false },
  Trirong: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: false,
  },
  Trispace: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  Trocchi: { weights: [400], variable: false },
  Trochut: { weights: [400, 700], variable: false },
  Truculenta: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Trykker: { weights: [400], variable: false },
  "Tsukimi Rounded": { weights: [300, 400, 500, 600, 700], variable: false },
  Tuffy: { weights: [400, 700], variable: false },
  "Tulpen One": { weights: [400], variable: false },
  "Turret Road": { weights: [200, 300, 400, 500, 700, 800], variable: false },
  "Twinkle Star": { weights: [400], variable: false },
  Ubuntu: { weights: [300, 400, 500, 700], variable: false },
  "Ubuntu Condensed": { weights: [400], variable: false },
  "Ubuntu Mono": { weights: [400, 700], variable: false },
  "Ubuntu Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
    variable: true,
  },
  "Ubuntu Sans Mono": { weights: [400, 500, 600, 700], variable: true },
  Uchen: { weights: [400], variable: false },
  Ultra: { weights: [400], variable: false },
  Unbounded: {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Uncial Antiqua": { weights: [400], variable: false },
  Underdog: { weights: [400], variable: false },
  "Unica One": { weights: [400], variable: false },
  UnifrakturCook: { weights: [700], variable: false },
  UnifrakturMaguntia: { weights: [400], variable: false },
  Unkempt: { weights: [400, 700], variable: false },
  Unlock: { weights: [400], variable: false },
  Unna: { weights: [400, 700], variable: false },
  UoqMunThenKhung: { weights: [400], variable: false },
  Updock: { weights: [400], variable: false },
  Urbanist: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  VT323: { weights: [400], variable: false },
  "Vampiro One": { weights: [400], variable: false },
  Varela: { weights: [400], variable: false },
  "Varela Round": { weights: [400], variable: false },
  Varta: { weights: [300, 400, 500, 600, 700], variable: true },
  "Vast Shadow": { weights: [400], variable: false },
  Vazirmatn: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Vend Sans": { weights: [300, 400, 500, 600, 700], variable: true },
  "Vesper Libre": { weights: [400, 500, 700, 900], variable: false },
  "Viaoda Libre": { weights: [400], variable: false },
  Vibes: { weights: [400], variable: false },
  Vibur: { weights: [400], variable: false },
  "Victor Mono": {
    weights: [100, 200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Vidaloka: { weights: [400], variable: false },
  Viga: { weights: [400], variable: false },
  "Vina Sans": { weights: [400], variable: false },
  Voces: { weights: [400], variable: false },
  Volkhov: { weights: [400, 700], variable: false },
  Vollkorn: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Vollkorn SC": { weights: [400, 600, 700, 900], variable: false },
  Voltaire: { weights: [400], variable: false },
  "Vujahday Script": { weights: [400], variable: false },
  "WDXL Lubrifont JP N": { weights: [400], variable: false },
  "WDXL Lubrifont SC": { weights: [400], variable: false },
  "WDXL Lubrifont TC": { weights: [400], variable: false },
  "Waiting for the Sunrise": { weights: [400], variable: false },
  Wallpoet: { weights: [400], variable: false },
  "Walter Turncoat": { weights: [400], variable: false },
  Warnes: { weights: [400], variable: false },
  "Water Brush": { weights: [400], variable: false },
  Waterfall: { weights: [400], variable: false },
  Wavefont: {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  Wellfleet: { weights: [400], variable: false },
  "Wendy One": { weights: [400], variable: false },
  Whisper: { weights: [400], variable: false },
  WindSong: { weights: [400, 500], variable: false },
  "Winky Rough": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Winky Sans": {
    weights: [300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Wire One": { weights: [400], variable: false },
  Wittgenstein: { weights: [400, 500, 600, 700, 800, 900], variable: true },
  "Wix Madefor Display": { weights: [400, 500, 600, 700, 800], variable: true },
  "Wix Madefor Text": { weights: [400, 500, 600, 700, 800], variable: true },
  "Work Sans": {
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  Workbench: { weights: [400], variable: false },
  "Xanh Mono": { weights: [400], variable: false },
  Yaldevi: { weights: [200, 300, 400, 500, 600, 700], variable: true },
  "Yanone Kaffeesatz": {
    weights: [200, 300, 400, 500, 600, 700],
    variable: true,
  },
  Yantramanav: { weights: [100, 300, 400, 500, 700, 900], variable: false },
  "Yarndings 12": { weights: [400], variable: false },
  "Yarndings 12 Charted": { weights: [400], variable: false },
  "Yarndings 20": { weights: [400], variable: false },
  "Yarndings 20 Charted": { weights: [400], variable: false },
  "Yatra One": { weights: [400], variable: false },
  Yellowtail: { weights: [400], variable: false },
  "Yeon Sung": { weights: [400], variable: false },
  "Yeseva One": { weights: [400], variable: false },
  Yesteryear: { weights: [400], variable: false },
  Yomogi: { weights: [400], variable: false },
  "Young Serif": { weights: [400], variable: false },
  Yrsa: { weights: [300, 400, 500, 600, 700], variable: true },
  Ysabeau: {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Ysabeau Infant": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Ysabeau Office": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Ysabeau SC": {
    weights: [1, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    variable: true,
  },
  "Yuji Boku": { weights: [400], variable: false },
  "Yuji Hentaigana Akari": { weights: [400], variable: false },
  "Yuji Hentaigana Akebono": { weights: [400], variable: false },
  "Yuji Mai": { weights: [400], variable: false },
  "Yuji Syuku": { weights: [400], variable: false },
  "Yusei Magic": { weights: [400], variable: false },
  "ZCOOL KuaiLe": { weights: [400], variable: false },
  "ZCOOL QingKe HuangYou": { weights: [400], variable: false },
  "ZCOOL XiaoWei": { weights: [400], variable: false },
  Zain: { weights: [200, 300, 400, 700, 800, 900], variable: false },
  "Zalando Sans": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Zalando Sans Expanded": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Zalando Sans SemiExpanded": {
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
    variable: true,
  },
  "Zen Antique": { weights: [400], variable: false },
  "Zen Antique Soft": { weights: [400], variable: false },
  "Zen Dots": { weights: [400], variable: false },
  "Zen Kaku Gothic Antique": {
    weights: [300, 400, 500, 700, 900],
    variable: false,
  },
  "Zen Kaku Gothic New": {
    weights: [300, 400, 500, 700, 900],
    variable: false,
  },
  "Zen Kurenaido": { weights: [400], variable: false },
  "Zen Loop": { weights: [400], variable: false },
  "Zen Maru Gothic": { weights: [300, 400, 500, 700, 900], variable: false },
  "Zen Old Mincho": { weights: [400, 500, 600, 700, 900], variable: false },
  "Zen Tokyo Zoo": { weights: [400], variable: false },
  Zeyada: { weights: [400], variable: false },
  "Zhi Mang Xing": { weights: [400], variable: false },
  "Zilla Slab": { weights: [300, 400, 500, 600, 700], variable: false },
  "Zilla Slab Highlight": { weights: [400, 700], variable: false },
};
